import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser'
import { TipoMovimientoService } from '../../../../../src/app/shared/services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';
import { DialogCargaMovimientoItem, DialogCargaMovimientoRequest, DialogCargaMovimientoResponse, DialogConfirmRequest, DialogConfirmResponse, SearchTipoMovimientoRequest, TipoMovimiento } from '../../../../../src/app/shared/model';
import { DialogConfirmComponent } from '../../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-dialogCargaMovimiento',
  templateUrl: 'dialogCargaMovimiento.component.html'
})

export class DialogCargaMovimientoComponent implements OnInit {

  @ViewChild('grid')
  public grid: GridComponent;

  public title: string;
  public message: any;
  public buttonAcceptText: string;
  public buttonCancelText: string;

  signo: number = 0;
  montoPendiente: number = 0;
  montoCuota: number = 0;
  movimientoList: DialogCargaMovimientoItem[];

  formGroup: FormGroup;

  isTipoMovimientoSearching: boolean = false;
  isEditing: boolean = false;

  tipoMovimientoList: TipoMovimiento[];
  tipoMovimientoPagoList: TipoMovimiento[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private dialogRef: MatDialogRef<DialogCargaMovimientoComponent>,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private tipoMovimientoService: TipoMovimientoService,
    @Inject(MAT_DIALOG_DATA) public data: DialogCargaMovimientoRequest
  ) {

  }

  ngOnInit() {
    this.title = this.data?.Title ?? 'Confirmación de la Operación';
    this.message = this.sanitizer.bypassSecurityTrustHtml(this.data?.Message ?? '¿Está seguro que desea continuar?');

    this.buttonAcceptText = this.data?.ButtonTextAccept ?? 'Aceptar';
    this.buttonCancelText = this.data?.ButtonTextCancel ?? 'Cancelar';

    this.signo = (this.data?.MontoTotal > 0 ? -1 : 1);
    this.data.MontoTotal *= (this.data?.MontoTotal > 0 ? 1 : -1);

    this.buildForm();
    this.getTiposMovimientos(this.signo);

    this.calcularMontos();
    this.updateTotalPendiente();

    this.formGroup.get("Importe")?.setValue(this.montoPendiente);
    this.formGroup.get("FechaInicioCuota")?.setValue(this.data?.FechaMovimiento);

    this.calcularMontos();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'grid-index': [null],
      'TipoMovimientoId': [null, Validators.required],
      'Importe': [this.montoPendiente, Validators.required],
      'CantidadCuotas': [1, Validators.min(1)],
      'FechaInicioCuota': [new Date()],
      'DiasRepeticionCuotas': [30],
      'PorcentajeAjusteCuota': [0, [Validators.min(0), Validators.max(100)]],
      'AplicarAjusteIncremental': [false],
      'MovimientoPagado': [true],
      'TipoMovimientoPagoId': [null],
      'MontoPagado': [null]
    });
  }

  getTiposMovimientos(signo: number) {
    var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, null, null, true);
    this.isTipoMovimientoSearching = true;

    this.tipoMovimientoService.search(r).subscribe(data => {
      this.isTipoMovimientoSearching = false;

      this.tipoMovimientoList = data?.result?.filter(f => f.Signo == signo);
      if (signo < 0)
        this.tipoMovimientoPagoList = data?.result?.filter(f => f.Signo > 0);
    },
    (err: HttpErrorResponse) => {
      this.isTipoMovimientoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onMovimientoPagadoChange() {
    if (this.formGroup.get('MovimientoPagado')?.value == true)
      this.formGroup.get('MontoPagado')?.setValue(this.montoCuota);
    else
      this.formGroup.get('MontoPagado')?.setValue(null);
  }

  onAccept() {
    if (this.movimientoList == null || this.movimientoList.length == 0) {
      this.sharedFunctions.showMessage("Debe cargar al menos un movimiento para continuar", "Error");
      return false;
    }

    if (this.montoPendiente > 0) {
      this.sharedFunctions.showMessage("Aún tiene " + this.data?.Moneda + " " + this.montoPendiente + " pendientes por cubrir", "Error");
      return false;
    }

    for (var i=0; i<this.movimientoList.length; i++)
      this.movimientoList[i].FechaInicioCuota = this.datePipe.transform(this.movimientoList[i].FechaInicioCuota, "yyyy-MM-dd");

    if (this.isEditing) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        data: new DialogConfirmRequest(
          "Confirmación de salida",
          "Tiene cambios que todavía no fueron guardados. <br/><br/>¿Desea descartarlos y salir de todos modos?",
          "Sí, descartar los cambios que no guardé",
          "No, voy a guardarlos antes"
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          var r = new DialogCargaMovimientoResponse(true, this.movimientoList);
          this.dialogRef.close(r);
        }
      });
    }
    else {
      var r = new DialogCargaMovimientoResponse(true, this.movimientoList);
      this.dialogRef.close(r);
    }
  }

  onDecline() {
    this.dialogRef.close(new DialogCargaMovimientoResponse(false, []));
  }

  getErrorTipoMovimientoId() {
    return this.formGroup.get('TipoMovimientoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorImporte() {
    var v = this.formGroup.get('Importe');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorCantidadCuotas() {
    var v = this.formGroup.get('CantidadCuotas');
    if (v?.hasError('min'))
      return 'Debe ingresar un valor mayor a 0';
    return '';
  }

  getErrorFechaInicioCuota() {
    var v = this.formGroup.get('FechaInicioCuota');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorDiasRepeticionCuotas() {
    var v = this.formGroup.get('DiasRepeticionCuotas');
    if (v?.hasError('maxlength'))
      return 'Límite de 300 caracteres alcanzado';
    return '';
  }

  getErrorPorcentajeAjusteCuota() {
    var v = this.formGroup.get('PorcentajeAjusteCuota');
    if (v?.hasError('min'))
      return 'El porcentaje debe ir entre 0 y 100';
    if (v?.hasError('max'))
      return 'El porcentaje debe ir entre 0 y 100';
    return '';
  }

  calcularMontos() {
    this.montoCuota = ((this.formGroup.get("Importe")?.value ?? 0) * (1 + ((this.formGroup.get('PorcentajeAjusteCuota')?.value ?? 0) / 100))) / (this.formGroup.get("CantidadCuotas")?.value ?? 1);
  }

  onClean() {
    this.buildForm();

    this.montoCuota = 0;
    this.isEditing = false;
  }

  onSave() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Debe completar todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (this.formGroup.get("MovimientoPagado")?.value == true) {
      var montoPagado = this.formGroup.get("MontoPagado")?.value;
      if (montoPagado == null || montoPagado == 0) {
        this.sharedFunctions.showMessage("Debe ingresar un monto de pago mayor a cero", "Error");
        return false;
      }

      var tipoMovPagoId = this.formGroup.get("TipoMovimientoPagoId")?.value;
      if (tipoMovPagoId == null || tipoMovPagoId == 0) {
        this.sharedFunctions.showMessage("Debe seleccionar un tipo de movimiento de pago", "Error");
        return false;
      }
    }

    var gridIndex = (this.formGroup.get("grid-index")?.value ?? -1);

    var r = new DialogCargaMovimientoItem(null, null, null, null, null, null, null, null, false, null, null);
    r = { ...this.formGroup.value };

    r.TipoMovimiento = this.tipoMovimientoList?.find(f => f.Id == r.TipoMovimientoId)?.Nombre ?? '';

    if (this.movimientoList == null)
      this.movimientoList = [];

    if (gridIndex >= 0)
      this.movimientoList[gridIndex] = r;
    else
      this.movimientoList.push(r);

    this.grid.refresh();

    this.updateTotalPendiente();
    this.onClean();
  }

  onEdit(data: any) {
    if (data != null) {
      this.formGroup.patchValue(data);
      this.formGroup.get("grid-index")?.setValue(data.index);
      this.isEditing = true;
    }
  }

  onDelete(data: any) {
    if (data != null && data.index >= 0) {
      this.movimientoList.splice(data.index, 1);
      this.grid.refresh();
      this.updateTotalPendiente();
    }
  }

  updateTotalPendiente() {
    var totalMovimientos = this.movimientoList?.reduce(function (accumulator, mov) {
      return accumulator + (mov.Importe != null ? parseFloat(mov.Importe.toString()) : 0);
    }, 0);

    this.montoPendiente = (this.data?.MontoTotal ?? 0) - (totalMovimientos ?? 0);
  }
}
